import styled from 'styled-components'
import { Row } from 'components/common/layout'
import { TbRefresh } from 'react-icons/tb'

export const ResetBtn: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <Button
    onClick={(e) => {
      onClick()
      e.stopPropagation()
    }}
  >
    <TbRefresh size={18} />
    <span>초기화</span>
  </Button>
)

export const Button = styled(Row)`
  gap: 4px;
  cursor: pointer;
  color: ${(p) => p.theme.color.gray1};
  font-size: ${(p) => p.theme.fontSize.default};
  :hover {
    color: ${(p) => p.theme.color.black1};
  }
`
